import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import TabMenu from 'js/components/Navigation/TabMenu'

type TotalItem = {
    title: string
    subtype: string
    total: number
}

type Props = {
    total: number
    totals?: TotalItem[]
    getSearchLink: (params: Record<string, any>) => string
    firstTabLabel: string
}

const SearchTabs = ({ total, totals, getSearchLink, firstTabLabel }: Props) => {
    const { t } = useTranslation()
    const location = useLocation()

    if (!totals || total === 0) {
        return null
    }

    const tabs = [
        {
            id: `search-tab-${firstTabLabel}`,
            link: getSearchLink({ subtype: null }),
            label: `${t(firstTabLabel)}`,
            isActive:
                location.pathname + location.search ===
                getSearchLink({ subtype: null }),
            ariaControls: `search-results-${firstTabLabel}`,
        },
        ...(totals.length > 1
            ? totals.map(({ title, subtype, total }) => {
                  const searchLink = getSearchLink({
                      subtype,
                  })

                  return {
                      id: `search-tab-${subtype}`,
                      link: searchLink,
                      label: `${title} (${total})`,
                      isActive:
                          location.pathname + location.search === searchLink,
                      ariaControls: `search-results-${subtype}`,
                  }
              })
            : []),
    ]

    return (
        <TabMenu
            options={tabs}
            style={{
                display: 'flex',
                justifyContent: 'center',
            }}
            label={t('search.search-results-by-type')}
        />
    )
}

export default SearchTabs
